// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tn-consent {
  position: fixed;
  left: 12px;
  right: 12px;
  bottom: 12px;
  z-index: 9998;
  background: #0a1628;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  padding: 14px 18px;
  /* Respect iOS safe-area so the banner clears the home indicator. */
  padding-bottom: max(14px, env(safe-area-inset-bottom));
}

.tn-consent__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 1180px;
  margin: 0 auto;
}

.tn-consent__copy {
  flex: 1 1 320px;
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
}

.tn-consent__link {
  color: #00a896;
  text-decoration: underline;
}

.tn-consent__actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.tn-consent__btn {
  appearance: none;
  border-radius: 6px;
  padding: 9px 16px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
}

.tn-consent__btn--primary {
  background: #00a896;
  border: 1px solid #00a896;
  color: #ffffff;
}

.tn-consent__btn--primary:hover {
  background: #008275;
  border-color: #008275;
}

.tn-consent__btn--ghost {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.85);
}

.tn-consent__btn--ghost:hover {
  border-color: rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.04);
}

.tn-consent__btn--link {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: underline;
  padding: 9px 8px;
}

.tn-consent__btn--link:hover { color: #fff; }

/* ===== Granular mode ===== */
.tn-consent__granular { display: flex; flex-direction: column; gap: 12px; }

.tn-consent__heading {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.tn-consent__cat {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  cursor: pointer;
  font-size: 13px;
}

.tn-consent__cat:first-of-type { border-top: none; }

.tn-consent__cat--locked { cursor: not-allowed; opacity: 0.7; }

.tn-consent__cat input[type="checkbox"] { margin-top: 3px; flex-shrink: 0; }

.tn-consent__cat strong { display: block; color: #fff; margin-bottom: 2px; }

.tn-consent__cat-desc {
  display: block;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.45;
}

@media (max-width: 600px) {
  .tn-consent { left: 8px; right: 8px; bottom: 8px; padding: 12px 14px; }
  .tn-consent__inner { flex-direction: column; align-items: stretch; }
  .tn-consent__actions { justify-content: flex-end; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConsentBanner/ConsentBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,+EAA+E;EAC/E,kBAAkB;EAClB,mEAAmE;EACnE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,+BAA+B,WAAW,EAAE;;AAE5C,8BAA8B;AAC9B,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE1E;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,eAAe;AACjB;;AAEA,iCAAiC,gBAAgB,EAAE;;AAEnD,2BAA2B,mBAAmB,EAAE,YAAY,EAAE;;AAE9D,0CAA0C,eAAe,EAAE,cAAc,EAAE;;AAE3E,0BAA0B,cAAc,EAAE,WAAW,EAAE,kBAAkB,EAAE;;AAE3E;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc,SAAS,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE;EACtE,qBAAqB,sBAAsB,EAAE,oBAAoB,EAAE;EACnE,uBAAuB,yBAAyB,EAAE;AACpD","sourcesContent":[".tn-consent {\n  position: fixed;\n  left: 12px;\n  right: 12px;\n  bottom: 12px;\n  z-index: 9998;\n  background: #0a1628;\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.4);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  padding: 14px 18px;\n  /* Respect iOS safe-area so the banner clears the home indicator. */\n  padding-bottom: max(14px, env(safe-area-inset-bottom));\n}\n\n.tn-consent__inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.tn-consent__copy {\n  flex: 1 1 320px;\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.tn-consent__link {\n  color: #00a896;\n  text-decoration: underline;\n}\n\n.tn-consent__actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.tn-consent__btn {\n  appearance: none;\n  border-radius: 6px;\n  padding: 9px 16px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n}\n\n.tn-consent__btn--primary {\n  background: #00a896;\n  border: 1px solid #00a896;\n  color: #ffffff;\n}\n\n.tn-consent__btn--primary:hover {\n  background: #008275;\n  border-color: #008275;\n}\n\n.tn-consent__btn--ghost {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.tn-consent__btn--ghost:hover {\n  border-color: rgba(255, 255, 255, 0.45);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.tn-consent__btn--link {\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: underline;\n  padding: 9px 8px;\n}\n\n.tn-consent__btn--link:hover { color: #fff; }\n\n/* ===== Granular mode ===== */\n.tn-consent__granular { display: flex; flex-direction: column; gap: 12px; }\n\n.tn-consent__heading {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.tn-consent__cat {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 8px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.tn-consent__cat:first-of-type { border-top: none; }\n\n.tn-consent__cat--locked { cursor: not-allowed; opacity: 0.7; }\n\n.tn-consent__cat input[type=\"checkbox\"] { margin-top: 3px; flex-shrink: 0; }\n\n.tn-consent__cat strong { display: block; color: #fff; margin-bottom: 2px; }\n\n.tn-consent__cat-desc {\n  display: block;\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.45;\n}\n\n@media (max-width: 600px) {\n  .tn-consent { left: 8px; right: 8px; bottom: 8px; padding: 12px 14px; }\n  .tn-consent__inner { flex-direction: column; align-items: stretch; }\n  .tn-consent__actions { justify-content: flex-end; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
